/*!

 =========================================================
 * Vue Now UI Kit - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App.vue";
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from "./router/router";
import NowUiKit from "./plugins/now-ui-kit";
import VueDraggable from "vue-draggable";
import store from "./store";
import { auth } from "./Firebase/firebase";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import Vue2Filters from "vue2-filters";

import VueScrollactive from "vue-scrollactive";
import PayWithBank3D from "@parkwayprojects/vue-paywithbank3d";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./main.css";
import "./vee-validate";
import './registerServiceWorker'

Vue.config.productionTip = false;

Vue.use(NowUiKit);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Vue2Filters);
Vue.use(VueDraggable);
Vue.use(require("vue-moment"));

Vue.use(VueScrollactive);


let app;
auth.onAuthStateChanged(() => {
  if (!app) {
    store.dispatch("Cart/setCart", localStorage.getItem("cart")).then(() => {
      app = new Vue({
        router,
        store,
        render: (h) => h(App),
      }).$mount("#app");
    });
  }
});
